<lt-item-items-view
  class="items"
  [alist]="alist"
  [alistLanguage]="alistLanguage"
></lt-item-items-view>
